import type { WebRTCEventArgs } from './types';
import { EventEmitter } from '@/lib/events';

export type WebRTCCallEvents = {
  ready: void;
  error: Error;
  callConnecting: WebRTCEventArgs;
  callConnected: WebRTCEventArgs;
  callStateChanged: WebRTCEventArgs;
  callHungUp: WebRTCEventArgs;
};

export class WebRTCCallEventBus extends EventEmitter<WebRTCCallEvents> {} 